<template>
    <div :class="`${className} img__section`">
        <div v-if="url" class="img__section-layout">
            <img class="previewImage" :src="url" @click="previewImage">
            <b-button @click="handleDeleteImage(keyUrl)" variant="danger img__section-button">{{$t('common.delete')}}</b-button>
        </div>
        <h4 v-else class="img__section-text">{{ $t('common.there_no_image_preview') }}</h4>
        <b-modal v-model="modalShow" id="modal-lg" size="lg" :hide-footer="true" :hide-header="true">
          <div class="modal-preview">
            <img :src="url" class="modal-img-preview" @click="previewImage">
          </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            default: ''
        },
        keyUrl: {
            type: String,
            default: ''
        },
        className: {
            type: String,
            default: ''
        },
        isModal: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return {
        modalShow: false
      }
    },
    methods: {
        handleDeleteImage(keyName) {
          this.$emit(`${this.isModal ? 'onDeleteImageModal' : 'onDeleteImage'}`, keyName);
        },
        previewImage() {
          this.modalShow = !this.modalShow
        }
    }
}
</script>

<style scoped>

  .img__section-layout {
    width: 100%;
    height: 100%;
  }

  .previewImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .previewImage:hover {
    cursor: zoom-in;
  }
  
  .modal-preview {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .modal-img-preview {
    max-height:100%; 
    max-width:100%;
  }

  .modal-img-preview:hover {
    cursor: zoom-out;
  }

  .img__section {
    position: relative;
    overflow: hidden;
    height: 100%;
    margin-top: .5rem;
    padding-bottom: 1rem;
  }

  .img__section-button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  .img__section-text {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    border: dashed;
    border-width: thin;
    border-color: #ccc;
    margin-bottom: 0;
    font-weight: 100;
  }
</style>


// WEBPACK FOOTER //
// src/components/Partials/ImagePreview.vue